import { render } from "./CategoryToggle.vue?vue&type=template&id=10b59303&scoped=true"
import script from "./CategoryToggle.vue?vue&type=script&lang=js"
export * from "./CategoryToggle.vue?vue&type=script&lang=js"

import "./CategoryToggle.vue?vue&type=style&index=0&id=10b59303&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10b59303"

export default script